<template lang="pug">
.container
  h2 搜尋關鍵字
  .search
    .teFilterBlock
      select(v-model="filter.currentColumn").filter.filter__columns
        option(
          v-for="item in filter.columns"
          :value="item.key"
        ) {{item.text}}
      input.filter.filter__kw(
        :disabled="filter.currentColumn === 'all'"
        v-model="filter.keyword"
        placeholder="搜尋關鍵字"
      )
      button.btn.btn-outline-primary(type='button') 搜尋
    .results
      h5 成果內容搜尋結果：
      table.table
        thead.thead-light
          tr
            th(scope="col") 標題
            th(scope="col") 日期
            th(scope="col") 作者
            th(scope="col") 連結
        tbody
          tr
            th(scope="row") 【東】區園藝植物營造幼兒園美感環境社群活動─園藝美學
            td 2020-12-07
            td 首頁管理員
            td
              button.btn.btn-outline-primary(@click="onApply(item)") 前往
          tr
            th(scope="row") 【東】區園藝植物營造幼兒園美感環境社群活動─園藝美學
            td 2020-12-07
            td 首頁管理員
            td
              button.btn.btn-outline-primary(@click="onApply(item)") 前往
          tr
            th(scope="row") 【東】區園藝植物營造幼兒園美感環境社群活動─園藝美學
            td 2020-12-07
            td 首頁管理員
            td
              button.btn.btn-outline-primary(@click="onApply(item)") 前往
      MyPagination(v-bind="pagination" @update:page="setPage")



</template>

<script>

import { searchLessonList } from '@/api/client/Lesson'
export default {
  data() {
    return {
      filter: {
        columns: [
          { key: 'all', text: '請先選擇要搜尋的內容' },
          { key: 's1', text: '計畫成果' },
          { key: 's2', text: '教學資源' },
          { key: 's3', text: '文化美感輕旅行' },
          { key: 's4', text: '藝拍即合-找補助' },
          { key: 's5', text: '藝拍即合-找教案' },

        ],
        keyword: null,
        currentColumn: 'all'
      },

      showPost: [
        {
          title: '',
          img: '',
          author: [],
          id: null,
          pro: '',
          domain: '',
        },
      ],
      pagination: {
        p: 1,
        lastPage: 1,
        amount: 15
      }
    }
  },
  async mounted() {
    await this.search({ column: 'all', page: 1 })
  },
  methods: {
    async setPage(page) {
      this.pagination.p = page
      const { currentColumn: column, keyword: kw } = this.filter
      await this.search({ column, kw, page })
    },
    async addPage(add) {
      let page = this.pagination.p + add
      const { lastPage } = this.pagination
      if (page < 1) {
        page = 1
      }
      if (page > lastPage) {
        page = lastPage
      }
      await this.setPage(page)
    },
    handelListData(data) {
      this.showPost = data.map(e => {
        const { id, authors, specialties, title, cover_photo, lesson_db_id, project_id, prj_name, summary } = e
        return {
          id,
          title,
          img: cover_photo,
          dbId: lesson_db_id,
          projectId: project_id,
          pro: summary,
          domain: specialties.map(e => e.name)
            .join('/').replaceAll('、', '/'),
          authors: authors.map(e => e.name)
            .join('/').replaceAll('、', '/')
        }
      })
    },
    getLastPage(totalNum) {
      if (totalNum) {
        let lastPage = Math.ceil(totalNum / this.pagination.amount)
        lastPage = lastPage === 0 ? 1 : lastPage
        this.pagination.lastPage = lastPage
      }
    },
    async search({ column, kw = "", page = 1 }) {
      const payload = ((column, kw, page) => {
        if (column === 'all' || column == null) {
          return { page }
        }
        // if (column) {
        return { column, kw, page }
        // }
        // return null
      })(column, kw, page)
      if (payload === null) {
        console.warn('search empty payload')
        return
      }
      const { total_num, data } = await searchLessonList(payload)
      this.getLastPage(total_num)
      this.handelListData(data)

    },

    gotoTeachPostLink(item) {
      const { id, dbId, projectId } = item
      this.$router.push({
        name: 'TeachPost',
        params: { postid: id },
        query: { dbId, projectId }
      })
    }
  },
  watch: {
    'filter.currentColumn': {
      async handler(nv, ov) {
        if (nv) {
          this.filter.keyword = null
          this.pagination.p = 1
        }
        if (nv === 'all') {
          await this.search({ page: 1, })
          return
        }
        await this.search({ column: nv, page: 1, })
      },
    },
    'filter.keyword': {
      async handler(nv, ov) {
        if (nv) {
          this.pagination.p = 1
          const { currentColumn: column } = this.filter
          await this.search({ column, kw: nv, page: 1 })
        }
      },
    }
  }
}

</script>

<style lang="sass" scoped>
@import '@/assets/style.sass'
.te
  width: 80%
  margin-left: 10%
  box-sizing: border-box
  margin-top: 6vw
  padding: 0 0 200px 0
  +phone
    width: 95%
    margin-left: 2.5%
    padding: 0 0 500px 0

    // min-width: 360px
    // min-height: 812px
  .teTop
    position: relative
    width: 100%
    // height: 3vw
    // margin-left: 10%
    margin-top: 3%
    box-sizing: border-box
    // +bb
    border-bottom: solid 1px #878787
    +flexrow
    flex-wrap: wrap
    +pad
      // height: 4vw
      margin-top: 1%
    +phone
      // display: none
      border: 0
      +flexcolumn
    .teName
      width: 15%
      margin-inline-end: 8px
      // +bb
      font-size: 30px
      font-weight: 800
      color: #878787
      +pad
        width: 15%
        // font-size: 2.5vw
      +phone
        width: max-content
        // font-size: 6vw
        font-weight: 800
        line-height: 170%
        color: black

    .teFilterBlock
        +smallcom
          font-size: 13px
          padding: 1px 0 0 0
        +pad
          height: 90%
          padding: 0
        +phone
          width: 100%
          height: 30px
          font-size: 20px
          margin-bottom: 10px
        .item_block
          position: absolute
          background-color: white
          border: solid 0.5px #D2D2D2
          border-radius: 6px
          top: 2.3vw
          width: 100%
          // height: 10vw
          box-sizing: border-box
          padding: 10px 0
          z-index: 99
          +pad
            top: 3vw
          +phone
            top: 35px
          .filterItem
            position: relative
            // margin-bottom: 5px
            border-top: solid 0.5px #999
            padding: 5px 0
            &:hover
              background-color: rgba(#333,0.5)
              color: white
            &:last-child
              border-bottom: solid 0.5px #999



  .teBottom
    width: 100%
    // height: 40vw
    // margin-left: 10%
    margin-top: 1%
    box-sizing: border-box
    position: relative
    // +bb
    +flexrow
    flex-wrap: wrap
    +pad
      margin-top: 2%
      height: auto
    +phone
      +flexcolumn
      width: 95%
      margin-left: 2.5%
      margin-top: 12%
      flex-wrap: initial
      height: auto
    .nodata
      position: absolute
      font-size: 20px
      letter-spacing: 1.5px
      font-weight: bold
      color: #D2D2D2
      left: 49%
      // top: 40%
      margin-top: 10%
      +pad
        left: 45%
      +phone
        left: 42%

    .teCard
      cursor: pointer
      width: 20%
      height: 18vw
      margin-bottom: 4%
      position: relative
      +smallcom
        width: 33%
        height: 33vw
        margin-bottom: 4vw

      +phone
        width: 100%
        // height: 33vw
        +flexrow
        border-bottom: solid 1px #878787
      .tePic
        position: relative
        width: 85%
        height: 68%
        // +bb
        // margin-left: 7.25%
        +pad
          width: 90%
          height: 65%
          margin-left: 5%
          margin-right: 5%
        +phone
          width: 40%
          height: 90%
          margin-left: 0
          margin-right: 0
      .teTextBlock
        width: 100%
        +phone
          width: 60%
        .teSubtitle
          width: 85%
          font-size: 0.8vw
          margin-top: 2%
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 1
          -webkit-box-orient: vertical

          +pad
            font-size: 1.8vw
            width: 90%
            letter-spacing: 0.1vw
            margin-left: 5%
            margin-right: 5%
          +phone
            width: 90%
            font-size: 3.3vw
            letter-spacing: 0.3vw
        .teTitle
          width: 85%
          font-size: 0.85vw
          margin-top: 2%
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          font-weight: 800

          +pad
            width: 90%
            font-size: 1.8vw
            letter-spacing: 0.1vw
            margin-left: 5%
            margin-right: 5%
          +phone
            width: 90%
            font-size: 4vw
            line-height: 7vw
            margin-top: 3%
        .tePro
          width: 85%
          font-size: 0.8vw
          margin-top: 1%
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          color: #878787

          +pad
            font-size: 1.8vw
            width: 90%
            letter-spacing: 0.1vw
            margin-left: 5%
            margin-right: 5%
          +phone
            width: 90%
            font-size: 4vw
            margin-top: 5%
            -webkit-line-clamp: 1
  .tePageList
    width: 100%
    height: 6vw
    margin-top: 2vw
    // +bb
    +flexrow
    justify-content: center
    +phone
      height: 6vw
      margin-top: 10%
    .tePrev
      width: 1%
      height: 40%
      background: url('../../assets/slide/prev.png')
      +bgcon
      // +bb
      background-position: 0 0
      background-size: 100% auto
      margin-right: 0.5vw
      opacity: 0.5
      margin-top: 0.1%
      cursor: pointer
      +pad
        width: 3%
        height: 100%
        margin-right: 1.8vw
      +phone
        width: 5%
        margin-right: 6vw
    .tePage
      font-size: 0.8vw
      margin-right: 0.5vw
      color: #878787
      cursor: pointer
      +pad
        font-size: 1.8vw
        margin-right: 1.8vw
      +phone
        // width: 5%
        margin-right: 6vw
        font-size: 4vw

      &.active
        color: black
    .teDot
      font-size: 0.8vw
      color: #878787
      margin-right: 0.5vw
      +pad
        font-size: 1.8vw
        margin-right: 1.8vw
      +phone
        width: 5%
        margin-right: 3.5vw
    .teFinal
      font-size: 0.8vw
      margin-right: 0.5vw
      color: #878787
      cursor: pointer
      +pad
        font-size: 1.8vw
        margin-right: 1.8vw
      +phone
        width: 5%
        margin-right: 3.5vw
        font-size: 3.5vw
    .teNext
      width: 1%
      height: 40%
      background: url('../../assets/slide/next.png')
      +bgcon
      // +bb
      background-position: 0 0
      background-size: 100% auto
      opacity: 0.5
      margin-top: 0.1%
      cursor: pointer
      +pad
        width: 3%
        height: 100%
      +phone
        width: 5%
.filter
  appearance: auto !important
  border-radius: 4px
  border: solid 0.5px #D2D2D2
  padding: 8px
  margin-block-end: 10px
  margin-inline-end: 10px
  height: 40px
  &__columns
    text-align: center
  &__kw
    min-width: 450px
    padding-left: 4px
    &[disabled]
      cursor: not-allowed
</style>



// WEBPACK FOOTER //
// src/views/Search/search.vue